import { cn } from 'components/UI/cn'
import { ToolbarDensity } from 'components/Tables/CommonTableCells/ToolbarDensityContext'
import { toolbarCountBadgeClass } from 'components/Tables/CommonTableCells/toolbarStyles'

/**
 * Shared styling for the Deals board toolbar's quick-filter triggers (Owner,
 * Visible Stages) so they stay visually identical. `focus:outline-none` drops
 * the browser's default blue focus ring that Radix surfaces when it returns
 * focus to the trigger after the menu closes — the open/closed state and the
 * count badge already communicate the control's state.
 *
 * Density-driven like the rest of the toolbar: pass the value from
 * `useToolbarDensity()` so the trigger reverts to md (38px) without a
 * `ToolbarDensityProvider` and shrinks to 32px under one — same pattern and
 * height as `TableButton` (explicit px, not Tailwind h-8, which is 28px at the
 * app's 14px root and would sit short of the px-height search shell / buttons).
 */
export function boardFilterTriggerClass(
  density: ToolbarDensity = 'md'
): string {
  return cn(
    'gap-2 !border-neutral-300 !text-neutral-800 hover:!bg-neutral-100 hover:!text-neutral-900 focus:outline-none focus-visible:outline-none',
    // sm: 32px + text-sm (12px) to match the TableButton-based "More Filters" in
    // the same row. Without !text-sm these fall back to FbButton's text-base
    // (14px at the 14px root), which is one step too large.
    density === 'sm' ? '!h-[32px] !min-h-[32px] !text-sm' : 'min-h-[38px]'
  )
}

/** The small "All" / count pill inside a board quick-filter trigger. Shared
 *  with TableButton's count chip via toolbarStyles. */
export const boardFilterBadgeClass = toolbarCountBadgeClass
